import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutHero from '../components/about/AboutHero';
import AboutStory from '../components/about/AboutStory';
import AboutValues from '../components/about/AboutValues';

export default function About() {
  return (
    <>
      <Helmet>
        {/* ── Core ── */}
        <title>About Us | SA Dropped — The Story Behind the Kicks</title>
        <meta name="description" content="SA Dropped started in Durban with a bedroom full of sneakers and a passion for street culture. Learn how we went from flipping pairs to shipping 12 000 plus orders nationwide." />
        <meta name="keywords" content="SA Dropped about us, sneaker store Durban, South Africa sneaker culture, streetwear South Africa, authentic sneakers SA, SA Dropped story" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.sadropped.co.za/about" />

        {/* ── Open Graph ── */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SA Dropped" />
        <meta property="og:title" content="About Us | SA Dropped — The Story Behind the Kicks" />
        <meta property="og:description" content="From a Durban bedroom to shipping nationwide. This is the SA Dropped story — built on passion, culture, and a love for the game." />
        <meta property="og:url" content="https://www.sadropped.co.za/about" />
        <meta property="og:image" content="https://www.sadropped.co.za/og-image.jpg" />
        <meta property="og:image:alt" content="SA Dropped — The Story Behind the Kicks" />
        <meta property="og:locale" content="en_ZA" />

        {/* ── Twitter ── */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@sa_dropped" />
        <meta name="twitter:title" content="About Us | SA Dropped — The Story Behind the Kicks" />
        <meta name="twitter:description" content="From a Durban bedroom to shipping nationwide. This is the SA Dropped story." />
        <meta name="twitter:image" content="https://www.sadropped.co.za/og-image.jpg" />

        {/* ── Schema.org ── */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About SA Dropped",
            "description": "SA Dropped is a Durban-based sneaker store founded in 2019. We ship verified authentic sneakers nationwide across South Africa.",
            "url": "https://www.sadropped.co.za/about",
            "publisher": {
              "@type": "Organization",
              "name": "SA Dropped",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.sadropped.co.za/logo_nav.png"
              },
              "foundingDate": "2019",
              "foundingLocation": {
                "@type": "Place",
                "name": "Durban, KwaZulu-Natal, South Africa"
              },
              "sameAs": [
                "https://www.instagram.com/sa_dropped"
              ]
            }
          }
        `}</script>
      </Helmet>

      <main>
        <AboutHero />
        <AboutStory />
        <AboutValues />
      </main>
    </>
  );
}